var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcoSelecionar01(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 36 36",
    style: {
      enableBackground: "new 0 0 36 36"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2213",
    transform: "translate(4.162 0.832)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2212"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1222",
    d: "M7.3,1.1H4.4c-0.4,0-0.7,0.3-0.7,0.7s0.3,0.7,0.7,0.7l0,0h2.9C7.7,2.6,8,2.2,8,1.8S7.7,1.1,7.3,1.1z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2215",
    transform: "translate(9.158 0.832)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2214"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1223",
    d: "M11,1.1H8.1c-0.4,0-0.7,0.3-0.7,0.7s0.3,0.7,0.7,0.7H11c0.4,0,0.7-0.3,0.7-0.7S11.4,1.1,11,1.1z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2217",
    transform: "translate(4.162 13.738)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2216"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1224",
    d: "M7.3,10.8H4.4c-0.4,0-0.7,0.3-0.7,0.7c0,0.4,0.3,0.7,0.7,0.7h2.9C7.7,12.3,8,12,8,11.6 C8,11.2,7.7,10.8,7.3,10.8z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2219",
    transform: "translate(9.158 13.738)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2218"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1225",
    d: "M11,10.8H8.1c-0.4,0-0.7,0.3-0.7,0.7c0,0.4,0.3,0.7,0.7,0.7H11c0.4,0,0.7-0.3,0.7-0.7 C11.8,11.2,11.4,10.8,11,10.8z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2221",
    transform: "translate(0.832 9.16)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2220"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1226",
    d: "M1.8,7.4c-0.4,0-0.7,0.3-0.7,0.7l0,0V11c0,0.4,0.3,0.7,0.7,0.7s0.7-0.3,0.7-0.7V8.1 C2.6,7.7,2.2,7.4,1.8,7.4C1.8,7.4,1.8,7.4,1.8,7.4z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2223",
    transform: "translate(0.832 4.164)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2222"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1227",
    d: "M1.8,3.6c-0.4,0-0.7,0.3-0.7,0.7l0,0v2.9C1.1,7.7,1.4,8,1.8,8s0.7-0.3,0.7-0.7V4.3 C2.6,3.9,2.2,3.6,1.8,3.6C1.8,3.6,1.8,3.6,1.8,3.6z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2225",
    transform: "translate(14.154 9.16)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2224"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1228",
    d: "M11.9,7.4c-0.4,0-0.7,0.3-0.7,0.7V11c0,0.4,0.3,0.7,0.7,0.7c0.4,0,0.7-0.3,0.7-0.7V8.1 C12.6,7.7,12.3,7.4,11.9,7.4C11.9,7.4,11.9,7.4,11.9,7.4z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2227",
    transform: "translate(14.154 4.164)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2226"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1229",
    d: "M11.9,3.6c-0.4,0-0.7,0.3-0.7,0.7v2.9c0,0.4,0.3,0.7,0.7,0.7c0.4,0,0.7-0.3,0.7-0.7V4.3 C12.6,3.9,12.3,3.6,11.9,3.6C11.9,3.6,11.9,3.6,11.9,3.6z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2229",
    transform: "translate(13.322)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2228"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1230",
    d: "M14.2,0.5h-2.9c-0.4,0-0.7,0.3-0.7,0.7v2.9c0,0.4,0.3,0.7,0.7,0.7h2.9c0.4,0,0.7-0.3,0.7-0.7V1.2 C14.9,0.8,14.6,0.5,14.2,0.5z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2231"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2230",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1231",
    d: "M4.1,0.5H1.2c-0.4,0-0.7,0.3-0.7,0.7c0,0,0,0,0,0v2.9c0,0.4,0.3,0.7,0.7,0.7c0,0,0,0,0,0h2.9 c0.4,0,0.7-0.3,0.7-0.7c0,0,0,0,0,0V1.2C4.9,0.8,4.5,0.5,4.1,0.5z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2233",
    transform: "translate(0 12.906)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2232",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1232",
    d: "M4.1,10.2H1.2c-0.4,0-0.7,0.3-0.7,0.7v2.9c0,0.4,0.3,0.7,0.7,0.7h2.9c0.4,0,0.7-0.3,0.7-0.7v-2.9 C4.9,10.5,4.5,10.2,4.1,10.2z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2235",
    transform: "translate(11.656 10.824)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2234"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1233",
    d: "M23.5,16L10.4,8.7C10,8.5,9.6,8.7,9.4,9c-0.1,0.2-0.1,0.4,0,0.6l5.8,14.6c0.1,0.3,0.4,0.5,0.7,0.5h0 c0.3,0,0.6-0.2,0.7-0.4l2.1-4.8l4.8-2.1c0.4-0.2,0.5-0.6,0.4-1C23.7,16.2,23.6,16.1,23.5,16L23.5,16z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoSelecionar01);
export default __webpack_public_path__ + "static/media/ico-selecionar-01.0eb0ecb196a8e3441cdda1b367b371fa.svg";
export { ForwardRef as ReactComponent };